import { Dispatch, SetStateAction } from 'react'
import { type Edge, type Node as ReactFlowNode } from '@xyflow/react'
import { NodeType } from './node-type.type'
import { IEvents, IEvent } from './event.type'
import { Direction } from '../algorithms'
import { IRun, NodeView } from '../../shared/types/api/playbook.type'
import { GridPaginationModel } from '@mui/x-data-grid'

export interface IPagination {
  skip: number
  take: number
  count: number
}

export interface IPlaybookContext {
  playbook: IPlaybook | undefined
  playbooks: IPlaybook[]
  user: string
  error: string
  nodeTypes: NodeType[]
  reactFlowNodes: ReactFlowNode[]
  spexNodes: Record<number, SpexNode>
  edges: Edge[]
  isLoading: boolean
  refreshList: () => void
  paginationModel: GridPaginationModel
  setPaginationModel: Dispatch<SetStateAction<GridPaginationModel>>
  search: string
  setSearch: Dispatch<SetStateAction<string>>
  total: number
  layoutOptions: IAutoLayout
  setUser: Dispatch<SetStateAction<string>>
  getPlaybook: (id: string) => void
  setLayoutOptions: Dispatch<SetStateAction<IAutoLayout>>
  setReactFlowNodes: Dispatch<SetStateAction<ReactFlowNode[]>>
  setSpexNodes: Dispatch<SetStateAction<Record<number, SpexNode>>>
  setEdges: Dispatch<SetStateAction<Edge[]>>
  handleRefresh: (playbook: IPlaybook) => void
  handleUpdate: (playbook: IPlaybook) => void
  getNodeTypes: () => void
  setPlaybooks: Dispatch<SetStateAction<IPlaybook[]>>
  setPlaybook: Dispatch<SetStateAction<IPlaybook | undefined>>
  savePlaybook: (playbook: IPlaybook) => Promise<void>
  runState: Record<string, any>
  setRunState: Dispatch<SetStateAction<Record<string, any>>>
  appendEvent: (playbookId: number, ev: IEvent) => void
}

// TODO: data is already a `Record<string, unknown>` on ReactFlowNode,
// so do we really need to make it `data: any` here?
export type SpexNode = ReactFlowNode & { data: any; view: NodeView }

// TODO: We should just use the IPlaybook from ../shared/types/api/playbook.type.ts
// TODO: This should have a list of our db nodes, not ReactFlow nodes.
export interface IPlaybook {
  id: number
  slug: string
  name: string
  created_at: Date
  direction: DirectionTypes
  status: 'running' | 'stopped'
  restart_on_failure: number
  events: IEvents
  auto_layout_options: IAutoLayout
  nodes: Array<SpexNode>
  edges: Array<Edge & { data: any }>
  runs: Array<IRun>
  custom_state: any
}

export interface IAutoLayout {
  algorithm: 'd3-hierarchy' | 'elk' | 'dagre'
  direction: Direction
}

export enum NotificationStatuses {
  SENT = 'Sent',
  SPAM = 'Spam',
  WAITING = 'Waiting',
}

export enum DirectionTypes {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
